<template>

  <b-row v-if="esFisiatria">
    <b-col>
      <b-card
       
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGÍA FISIÁTRICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 0 1.5rem">

            <b-tabs card>
              <b-tab title="Preguntas" active>
                <PreguntasFisiatria/>
              </b-tab>
              <b-tab title="Escalas">
                <EscalasFisiatricas/>
              </b-tab>
            </b-tabs>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from 'vuex';
import PreguntasFisiatria from './PreguntasFisiatria.vue';
import EscalasFisiatricas from './EscalasFisiatricas.vue';

export default {
  name: "SemiologiaFisiatrica",

  components: {
    PreguntasFisiatria,
    EscalasFisiatricas
  },

  data() {
    return {
      visibleBody: true,
    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    }
  },

  computed: {
    ...mapState({
      stEspecialidad : state => state.atencionCita.dataCita?.doctor.especialidad,
      stSemFisiatrica: state => state.atencionCita.semiologias?.semFisiatrica,
    }),

    esFisiatria(){
      return this.stEspecialidad?.codEsp === '0000000126';
    },
  },

  watch:{

    stSemFisiatrica: {
      deep: true,
      handler(newValue) {
        const semiologia = { tipo:'fisiatrica', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
    },

  }

  
}
</script>

<style>
  .checkbox-sintomas .custom-check {
    width: 100%;
  }

  .otros-check .custom-control-label{
    display: flex;
    width: 100%;
  } 
</style>
